const initialState = {
  loading: false,
  errors: {},
  data: {},
};

const setLineItems = (stateData, payload) => {
  const newStateData = JSON.parse(JSON.stringify(stateData));
  newStateData[payload.referenceId] = payload.lineItems;
  return newStateData;
};

const payRateLineItems = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'PAY_RATE_LINE_ITEM_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'PAY_RATE_LINE_ITEM_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        data: setLineItems(state.data, payload),
      };
    case 'PAY_RATE_LINE_ITEM_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default payRateLineItems;



// WEBPACK FOOTER //
// ./client/app/reducers/pay_rate_line_items.js